import useBulkUserWalletTicketData from '../../hooks/useBulkUserWalletTicketData'

interface Props {
  eventId: number
}

const TicketDataFetcher: React.FC<Props> = (props: Props) => {
  const { eventId } = props

  useBulkUserWalletTicketData({ eventId })

  return null
}

export default TicketDataFetcher
